import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (d204/models/models.go)
// ============================================================

export interface FD140 {
  fd140_01: string;        // 入庫單號 (PK)
  fd140_10: string;        // 加工廠代號
  fd140_11: string;        // 託工單號
  fd140_12: string | null; // 入庫日期
  fd140_121: string | null; // 備用日期
  fd140_13: string;        // 庫位代號
  fd140_14: number;        // 量縮率
  fd140_15: string;        // 備用
  fd140_16: number;        // 工繳總金額
  fd140_161: number;       // 含稅金額
  fd140_17: number;        // 稅額
  fd140_181: string;       // 產品代號前段
  fd140_182: string;       // 產品代號後段
  fd140_19: number;        // 平均單價
  fd140_20: number;        // 本次投入量
  fd140_201: number;       // 投入量計算值
  fd140_21: number;        // 總入庫量
  fd140_22: number;        // 樣品數量
  fd140_23: number;        // 備用
  fd140_24: string;        // 備用
  fd140_25: number;        // 入庫類型
  fd140_251: boolean;      // 備用
  fd140_26: string;        // 備用
  fd140_27: string | null; // 備用日期
  fd140_28: string;        // 備用
  fd140_29: string | null; // 備用日期
  fd140_30: string;        // 備用
  fd140_31: number;        // 備用
  fd140_33: string;        // 備用
  fd140_34: string;        // 備用
  fd140_35: number;        // 總項數
  fd140_36: string;        // 幣別
  fd140_37: number;        // 匯率
  fd140_40: number;        // 計費方式(1=計量,2=一缸)
  fd140_41: string;        // 備用
  fd140_42: number;        // 備用
  fd140_43: string;        // 建檔人員
  fd140_44: string | null; // 核准日期
  fd140_45: string;        // 核准人員
  fd140_51: string;        // 產品名稱
  fd140_52: string;        // 產品規格
  fd140_53: string;        // 加工別
  fd140_54: number;        // 幅寬-針孔內
  fd140_55: number;        // 幅寬-針孔外
  fd140_56: number;        // 碼重
  fd140_57: number;        // 米平方重
  fd140_58: string | null; // 備用日期
  fd140_59: string;        // 備用
  fd140_60: string;        // 備用
  fd140_61: string;        // 備用
  fd140_62: boolean;       // 備用
  fd140_63: boolean;       // 重修再入庫
  fd140_64: boolean;       // 停用工繳
  fd140_65: string | null; // 備用日期
  fd140_66: string;        // 版本碼
  fd140_67: boolean;       // 三聯式發票
  fd140_80: string;        // 核准狀態(N/S/P/R)
  fd140_81: string;        // 取消狀態
  fd140_87: string;        // 備用
  fd140_88: string | null; // 備用日期
  fd140_89: string;        // 備用
  fd140_90: number;        // 版次
  fd140_91: string;        // 修改人員
  fd140_92: string | null; // 修改日期
  fd140_93: string;        // 修改時間
  fd140_94: string;        // 備用
  fd140_353: number;       // 備用
  fd140_38: string;        // 領用單號

  // Associations
  details?: FD141[];
  lot_details?: FD142[];
  attachments?: FD143[];
}

export interface FD141 {
  fd141_01: string;   // 入庫單號 (FK)
  fd141_02: number;   // 序號
  fd141_11: string;   // 等級代號
  fd141_111: string;  // 等級名稱
  fd141_12: string;   // 顏色代號
  fd141_12a: string;  // 顏色備用碼
  fd141_13: string;   // 單位
  fd141_14: number;   // 工繳單價
  fd141_141: number;  // 一缸工繳
  fd141_142: number;  // 其他單價
  fd141_143: number;  // 其他單價2
  fd141_15: number;   // 入庫數量
  fd141_16: number;   // 工繳金額
  fd141_161: number;  // 含稅金額
  fd141_17: number;   // 備用
  fd141_18: number;   // 備用
  fd141_19: number;   // 單位換算率
  fd141_20: string;   // 顏色英文名
  fd141_21: number;   // 託SEQ
  fd141_22: number;   // S/C項次
  fd141_23: number;   // 備用
  fd141_24: string;   // 備用
  fd141_25: string;   // 備用
  fd141_26: number;   // 備用
  fd141_27: string;   // 打色通知單號
  fd141_28: string;   // S/C-NO
  fd141_29: number;   // 編輯權限
  fd141_90: number;   // 版次
  fd141_301: string;  // 產品代號前段
  fd141_302: string;  // 產品代號後段
  fd141_33: boolean;  // 備用
  fd141_34: string;   // 備用
}

export interface FD142 {
  fd142_01: string;   // 入庫單號 (FK)
  fd142_02: number;   // 明細序號 (FK)
  fd142_03: number;   // 板號
  fd142_11: string;   // 缸號
  fd142_12: string;   // 備用
  fd142_13: string;   // 備用
  fd142_90: number;   // 版次
}

export interface FD143 {
  fd143_01: string;
  fd143_02: number;
  fd143_11: string;
  fd143_12: string;
  fd143_13: string | null;
  fd143_14: string;
}

// ============================================================
// Request / Response types
// ============================================================

export interface D204ListResponse {
  data: FD140[];
  total: number;
  page: number;
  size: number;
}

export interface D204CreateRequest {
  master: Partial<FD140>;
  details: Partial<FD141>[];
  lot_details: Partial<FD142>[];
}

export interface D204UpdateRequest {
  master: Partial<FD140>;
  details: Partial<FD141>[];
  lot_details: Partial<FD142>[];
}

// ============================================================
// Approval types
// ============================================================

export interface ApprovalResponse {
  order_no: string;
  action: string;
  old_status: string;
  new_status: string;
  message: string;
}

export interface ApprovalHistory {
  id: number;
  order_no: string;
  action: string;
  actor_id: string;
  actor_name: string;
  comment: string;
  old_status: string;
  new_status: string;
  created_at: string;
}

// ============================================================
// API methods
// ============================================================

export const d204Api = {
  async list(page = 1, size = 20): Promise<D204ListResponse> {
    const res = await apiClient.get('/api/d204', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<FD140> {
    const res = await apiClient.get(`/api/d204/${encodeURIComponent(id)}`);
    return res.data;
  },

  async previewFromSubcontractOrder(orderNo: string): Promise<FD140> {
    const res = await apiClient.get(`/api/d204/from-subcontract/${encodeURIComponent(orderNo)}`);
    return res.data;
  },

  async create(data: D204CreateRequest): Promise<FD140> {
    const res = await apiClient.post('/api/d204', data);
    return res.data;
  },

  async update(id: string, data: D204UpdateRequest): Promise<FD140> {
    const res = await apiClient.put(`/api/d204/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/d204/${encodeURIComponent(id)}`);
  },

  // Approval workflow
  async submitForApproval(id: string, comment?: string): Promise<ApprovalResponse> {
    const res = await apiClient.post(`/api/d204/${encodeURIComponent(id)}/submit`, { comment: comment || '' });
    return res.data;
  },

  async approve(id: string, comment?: string): Promise<ApprovalResponse> {
    const res = await apiClient.post(`/api/d204/${encodeURIComponent(id)}/approve`, { comment: comment || '' });
    return res.data;
  },

  async reject(id: string, comment?: string): Promise<ApprovalResponse> {
    const res = await apiClient.post(`/api/d204/${encodeURIComponent(id)}/reject`, { comment: comment || '' });
    return res.data;
  },

  async writeoff(id: string, comment?: string): Promise<ApprovalResponse> {
    const res = await apiClient.post(`/api/d204/${encodeURIComponent(id)}/writeoff`, { comment: comment || '' });
    return res.data;
  },

  async getApprovalHistory(id: string): Promise<ApprovalHistory[]> {
    const res = await apiClient.get(`/api/d204/${encodeURIComponent(id)}/approval-history`);
    return res.data.data || [];
  },

  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
